import PropTypes from 'prop-types';

export default PropTypes.shape({
  addLayer: PropTypes.func.isRequired,
  removeLayer: PropTypes.func.isRequired
});